var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(-1186, -123)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1199.55714,123.187381 L1206.42857,128.571424 L1211.07143,128.571424 C1211.584,128.571424 1212,129.001167 1212,129.518567 L1212,149 L1200.85714,149 L1200.85714,142.441495 L1197.14286,142.441495 L1197.14286,149 L1186,149 L1186,129.518567 C1186,129.001167 1186.41581,128.571424 1186.92857,128.571424 L1191.57143,128.571424 L1198.44286,123.187381 C1198.77306,122.93754 1199.22694,122.93754 1199.55714,123.187381 Z M1205.81014,130.428567 L1199,124.866201 L1192.19041,130.428567 L1187.85714,130.428567 L1187.85714,147.151952 L1195.28571,147.151952 L1195.28571,140.642853 L1202.71429,140.642853 L1202.71429,147.151952 L1210.14286,147.151952 L1210.14286,130.428567 L1205.81014,130.428567 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.948e2ac38d593add20089ee9a7c9da4b.svg";
export { ForwardRef as ReactComponent };